window.mindfulchef = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            linkButton: '#link-my-mindful-chef-account',
            createAccountButton: '#create-new-mindful-chef-account',
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                $(self.elements.linkButton).on('click', self.func.addAccountLinkGtm);
                $(self.elements.createAccountButton).on('click', self.func.createAccountGtm);
            },
            addAccountLinkGtm: function () {
                self.func.addGtmTag('link_account');
            },
            createAccountGtm: function () {
                self.func.addGtmTag('create_account');
            },
            addGtmTag: function (ctaText) {
                window.dataLayer.push({event: 'mindfulChefCta', cta_text: ctaText});
            }
        }
    };
    return {
        init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    const healthReviewToggle = ($('#page-data').data('feature-toggle') === 'True')
    if(healthReviewToggle) {
        $("#health-review-toggle-on").show();
        $("#health-review-toggle-off").hide();
    }
    else {
        $("#health-review-toggle-on").hide();
        $("#health-review-toggle-off").show();
    }
    if ($('#link-my-mindful-chef-account').length > 0) {
        window.mindfulchef.init();
    }
});
